import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "fw-bold mb-1" };
const _hoisted_2 = { class: "mb-3 text-secondary" };
const _hoisted_3 = {
    key: 0,
    class: "alert alert-danger mb-3",
    role: "alert"
};
const _hoisted_4 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_5 = { class: "row mb-4" };
const _hoisted_6 = { class: "col-lg-6 col-12" };
const _hoisted_7 = { class: "form-check mb-3" };
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, useForm } from '@inertiajs/vue3';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import ProductPriceOption from '@/Tenant/Components/ProductPriceOption.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        deliveryTypeCountry: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatDate } = formatters();
        const props = __props;
        const editForm = useForm({
            active: props.deliveryTypeCountry?.active ?? false
        });
        function update() {
            editForm.transform((data) => ({
                active: data.active
            }))
                .submit('put', route('admin.deliveryTypes.countries.update', props.deliveryTypeCountry.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Versandart - Länderoption" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Versandart: " + _toDisplayString(props.deliveryTypeCountry.deliveryTypeName) + " | Länderoption: " + _toDisplayString(props.deliveryTypeCountry.name), 1),
                        _createElementVNode("p", _hoisted_2, "Letzte Änderung: " + _toDisplayString(_unref(formatDate)(props.deliveryTypeCountry.updatedAt, true)), 1),
                        (props.deliveryTypeCountry.priceBundle && !props.deliveryTypeCountry.priceBundle.active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Versandart ist mit einem inaktiven Preis-Bundle verknüpft. Versandart kann somit nicht eingesetzt werden."))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(update, ["prevent"])
                                    }, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "active",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editForm).active) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(editForm).active]
                                            ]),
                                            _cache[1] || (_cache[1] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "active"
                                            }, "Aktiv (Länderoption kann genutzt werden)", -1))
                                        ]),
                                        _cache[2] || (_cache[2] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32)
                                ])
                            ]),
                            _createElementVNode("div", null, [
                                _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preise", -1)),
                                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-1 fw-bold" }, "Min. Anzahl = Min. Gewicht in kg", -1)),
                                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "fw-bold" }, "Max. Anzahl = Max. Gewicht in kg", -1)),
                                _createVNode(ProductPriceOption, {
                                    deliveryTypeCountry: props.deliveryTypeCountry,
                                    priceBundleUuid: props.deliveryTypeCountry.priceBundleUuid
                                }, null, 8, ["deliveryTypeCountry", "priceBundleUuid"])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
